import { Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { t } from "i18next";
import { Hourglass } from "lucide-react";
import { TabsContentProps } from "./TabsContent.types";
import {
  CardEdition,
  GridBox
} from "../../components";
import { EnrollmentPollingProvider } from "../../context/EnrollmentPollingContext";
import { InfoBanner } from "../InfoBanner/InfoBanner.component";

export function TabsContentEditions({
  contentEditions,
  courseId,
  currentLO,
  rootId,
  titleEditions,
  currentTeachers=[],
  enrollableEditionsWithSessions,
  isPollingEditionChange,
  onChangeEditionClick
} :
  & Pick<
  TabsContentProps,
  | "courseId"
  | "currentLO"
  | "rootId"
  | "currentTeachers"
  | "enrollableEditionsWithSessions"
  | "isPollingEditionChange"
  | "onChangeEditionClick"
  >
  & Required<
    Pick<
    TabsContentProps,
    | "contentEditions"
    | "titleEditions"
    >
  >
) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const showVirtualClassPending = (currentLO?.learningObjectTypology === "DA_VIRTUAL_CLASS" || currentLO?.learningObjectTypology === "DA_PHYSICAL_CLASS") && currentLO?.status === "T";

  return (
    <EnrollmentPollingProvider>
      {
        showVirtualClassPending ?
          <InfoBanner
            backgroundColor={ theme.customColors.backgroundSecondaryAlternative }
            borderColor={ theme.customColors.backgroundAccent }
            textColor={ theme.customColors.textTag }
            description={ t(currentLO?.learningObjectTypology === "DA_VIRTUAL_CLASS" ? "virtual_class_pending" : "physical_class_pending") }
            icon={ <Hourglass/>
            }/> :
          <Typography
            fontSize="20px"
            lineHeight="21px"
            marginBottom={ theme.spacing(3) }
          >
            { titleEditions }
          </Typography>
      }
      <GridBox columns={ isMobile ? 1 : 2 }>
        {
          !showVirtualClassPending && currentLO && contentEditions?.map((edition, index) => (
            <CardEdition
              courseId={ courseId }
              key={ index }
              booked={ Boolean(edition?.status === "E") }
              bookedSeats={ edition.occupiedPlaces }
              editionId={ edition.id }
              endTime={ edition.endTime }
              extraInfo={ edition.extraInfo ?? edition.extra_info }
              enrollType={ currentLO.enrollType }
              enrollmentStatus={ currentLO.enrollmentStatus || "" }
              gMapsUrl={ edition.gMapsUrl }
              hasEditionEnrolled={ Boolean(contentEditions.find(edition => edition.status === "E" && edition.isAbsent === false) ) }
              hasEditionEnrolledAbsent={ Boolean(contentEditions.find(edition => (edition.status === "E" || edition.status === "P") && edition.isAbsent === true) ) }
              id={ currentLO.id }
              learningObjectTypology={ currentLO?.learningObjectTypology }
              link={ edition.link || null }
              location={ edition.location }
              maxSeats={ edition.totalPlaces }
              rooms={ edition.rooms }
              rootId={ rootId }
              startTime={ edition.startTime }
              status={ currentLO?.status || "N" }
              statusEdition={ edition.status }
              currentTeachers={ currentTeachers }
              selfEnrollment={ currentLO?.selfEnrollment }
              currentLO={ currentLO }
              attributesIds={ currentLO.attributes }
              isAbsent={ edition.isAbsent }
              enrollableEditionsWithSessions={ enrollableEditionsWithSessions }
              contentEditions={ contentEditions }
              isPollingEditionChange={ isPollingEditionChange }
              onChangeEditionClick={ onChangeEditionClick }
            />
          ))
        }
      </GridBox>
    </EnrollmentPollingProvider>
  );
}
